import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import ResultLink from "../../components/Search/ResultLink";

import LoadingCircle from "../../components/Loading/LoadingCircle";
import menu from "../../menu";

class Search extends Component {
  constructor(props) {
    super(props);
    this.isSmallDevice = this.isSmallDevice.bind(this);

    this.state = {
      searchOpen: false,
      txtSearch: "",
      fullScreen: false,
      searching: false,
      results: []
    };

    this.timer = {};

    this.master = [];
    for (var i = 0; i < menu.length; i++) {
      for (var m = 0; m < menu[i].menu.length; m++) {
        if (menu[i].menu[m].heading !== true) {
          this.master.push({
            title: menu[i].section + " " + menu[i].menu[m].title,
            link: menu[i].section + "/" + menu[i].menu[m].link,
            section: menu[i].section,
            keywords: menu[i].menu[m].keywords,
            description: menu[i].menu[m].description
          });
        }
      }
    }
  }

  componentDidMount() {
    this.isSmallDevice();
    window.addEventListener("resize", this.isSmallDevice);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.isSmallDevice);
    if (this.timer.changeTimerID !== undefined) {
      clearTimeout(this.timer.changeTimerID);
    }
  }

  isSmallDevice() {
    if (this.state.fullScreen !== window.outerWidth < 600) {
      this.setState({
        fullScreen: window.outerWidth < 600
      });
    }
  }

  openSearch() {
    this.isSmallDevice();
    this.setState({
      searchOpen: true,
      txtSearch: ""
    });
  }

  closeSearch() {
    this.setState({
      searchOpen: false
    });
  }

  runSearch() {
    if (this.timer.changeTimerID !== undefined) {
      clearTimeout(this.timer.changeTimerID);
    }

    var phrase = this.state.txtSearch.toLowerCase();
    var results = [];
    var words = phrase.split(" ");
    var pairs = [];

    if (words.length >= 2) {
      for (var i = 1; i < words.length; i++) {
        pairs.push(words[i - 1] + " " + words[i]);
      }
    }

    for (var i = 0; i < this.master.length; i++) {
      this.master[i].score = 0;

      for (var n = 0; n < words.length; n++) {
        if (words[n].length >= 2) {
          if (
            (" " + this.master[i].title.toLowerCase() + " ").indexOf(
              " " + words[n] + " "
            ) !== -1
          ) {
            this.master[i].score += 6;
          }
          if (
            (" " + this.master[i].keywords.toLowerCase() + " ").indexOf(
              " " + words[n] + " "
            ) !== -1
          ) {
            this.master[i].score += 4;
          }
          if (
            (" " + this.master[i].description.toLowerCase() + " ").indexOf(
              " " + words[n] + " "
            ) !== -1
          ) {
            this.master[i].score += 2;
          }
        }
      }

      for (var n = 0; n < pairs.length; n++) {
        if (pairs[n].length >= 2) {
          if (
            (" " + this.master[i].title.toLowerCase() + " ").indexOf(
              " " + pairs[n] + " "
            ) !== -1
          ) {
            this.master[i].score += 3;
          }
          if (
            (" " + this.master[i].keywords.toLowerCase() + " ").indexOf(
              " " + pairs[n] + " "
            ) !== -1
          ) {
            this.master[i].score += 2;
          }
          if (
            (" " + this.master[i].description.toLowerCase() + " ").indexOf(
              " " + pairs[n] + " "
            ) !== -1
          ) {
            this.master[i].score += 1;
          }
        }
      }

      if (this.master[i].score !== 0) {
        results.push(this.master[i]);
      }

      results.sort(function(a, b) {
        return a.score > b.score ? -1 : a.score < b.score ? 1 : 0;
      });

      results.slice(0, 20);
    }

    this.setState({
      searching: false,
      results: results
    });
  }

  handleUnfocusClose = () => {
    this.setState({ searchOpen: false });
  };

  searchChange(e, event) {
    this.setState({
      txtSearch: event.target.value
    });

    if (event.target.value.length >= 3) {
      this.setState({
        searching: true
      });

      if (this.timer.changeTimerID !== undefined) {
        clearTimeout(this.timer.changeTimerID);
      }
      this.timer.changeTimerID = setTimeout(() => {
        this.runSearch();
      }, 600);
    }
  }

  render() {
    var that = this;

    var ListResults = this.state.results.map(function(item, index) {
      return (
        <ResultLink
          key={index}
          onClick={e => that.closeSearch(e)}
          to={item.link}
          primary={item.title}
          secondary={item.description}
        />
      );
    });

    return (
      <div>
        <Button
          onClick={e => this.openSearch(e)}
          mini
          variant="fab"
          aria-label="Search"
          style={{ backgroundColor: "#0099ED", outline: "none" }}
        >
          <i className="material-icons" style={{ color: "#ffffff" }}>
            search
          </i>
        </Button>

        <Dialog
          open={this.state.searchOpen}
          onClose={this.handleUnfocusClose}
          fullScreen={this.state.fullScreen}
        >
          <DialogTitle id="alert-dialog-title">
            Search Nexoid Developer
          </DialogTitle>

          <DialogContent
            style={{ minWidth: this.state.fullScreen ? undefined : 500 }}
          >
            <TextField
              label="Search"
              value={this.state.txtSearch}
              onChange={this.searchChange.bind(this, this)}
              margin="normal"
              fullWidth={true}
              placeholder={"What are you looking for?"}
              onKeyPress={ev => {
                if (ev.key === "Enter") {
                  this.runSearch();
                }
              }}
              autoFocus={true}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <i className="material-icons" style={{ color: "#000000" }}>
                      search
                    </i>
                  </InputAdornment>
                )
              }}
            />
            {this.state.searching === true ? (
              <div>
                <div style={{ paddingTop: 30, paddingBottom: 10 }}>
                  <LoadingCircle />
                </div>
              </div>
            ) : (
              <div>
                {this.state.txtSearch.length <= 2 ? (
                  <div></div>
                ) : (
                  <div>
                    {this.state.results.length === 0 ? (
                      <div
                        style={{
                          paddingTop: 30,
                          paddingBottom: 10,
                          color: "rgba(0,0,0,0.87)"
                        }}
                      >
                        No results found.
                      </div>
                    ) : (
                      <div className="searchResults">{ListResults}</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={e => this.closeSearch(e)}
              style={{ color: "#2C67B1", marginLeft: "auto" }}
            >
              close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Search;

// hmr-touch-2



// WEBPACK FOOTER //
// ./src/components/Search/Search.js